import _createForOfIteratorHelper from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
import { fetchAlarmUsers } from '@api/u8.api.alarm.user';
export default {
  data: function data() {
    return {
      options: []
    };
  },
  props: {
    value: {
      default: []
    }
  },
  computed: {
    listeners: function listeners() {
      var _this = this;

      return _objectSpread(_objectSpread({}, this.$listeners), {}, {
        // Override input listener to work with v-model
        input: function input(event) {
          return _this.$emit('input', event);
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchData(true);
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      //获取数据
      fetchAlarmUsers({}).then(function (res) {
        if (res && res.length > 0) {
          var _iterator = _createForOfIteratorHelper(res),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              item.id = item.id + '';
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        _this2.options = res;
      }).catch(function (err) {
        console.log('err', err);
      });
    }
  }
};